<template>
  <a
    class="user-tooltip"
    @click="openHelpPopUp('data.html')"
  >
    <img
      :src="`${userCommonImageUrlForPc}/tooltip_help_pc.png`"
      alt="データの説明"
    >
  </a>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  mixins: [jobPreviewCommon]
}
</script>
